import React, {Component} from 'react'
import propTypes from 'prop-types'
import ReactDOM from 'react-dom'
import {isNil} from 'lodash'
import ColumnHeader, {MinColumnSize} from './columnHeader'
import Draggable from '../../../components/draggable'
import DragLayer from '../../../components/dragLayer'
import {prefix} from 'helpers/component'

const getClassName = prefix('pivotTable-columnHeaders-')

class ColumnHeaders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dragIndex: null,
    }
  }

  setColumn = (col, index) => {
    if (isNil(this.columns)) this.columns = []
    this.columns[index] = col
  }

  columnDrag = (index, pos) => {
    const {columns, controlColumns} = this.props

    let dragPos = 0
    let dragIndex = 0
    if (controlColumns) controlColumns.forEach(c => dragPos += c.size)

    for (let i = 0; i < columns.length; i++) {
      const col = this.columns[i]
      const node = ReactDOM.findDOMNode(col)
      const size = node.offsetWidth

      const midPoint = dragPos + (size / 2)
      if (midPoint > pos.cursor.x) break

      dragPos += size
      dragIndex++
    }

    this.setState({dragIndex})
  }

  columnDrop = (index) => {
    let newIndex = this.state.dragIndex
    if (newIndex != null) {
      if (newIndex > index) newIndex--
      if (newIndex !== index) this.props.onMove(index, newIndex)
    }
    this.setState({dragIndex: null})
  }

  render() {
    const {
      columns,
      controlColumns,
      columnSizes,
      sortColumn,
      sortDirection,
      sortingAllowed,
      columnResizingAllowed,
      columnReorderAllowed,
      stickyTop,
      onSort,
      onMove,
      onSize,
      actionColumns,
    } = this.props
    const {dragIndex} = this.state

    let content = columns.map((c, index) => {
      let size = columnSizes[c.key]
      if (size == null) size = c.size
      if (size == null) size = 100
      if (size < MinColumnSize) size = MinColumnSize

      return (
          <Draggable
              key={c.key}
              ref={e => {
                this.setColumn(e, index)
              }}
              axis="x"
              active={columnReorderAllowed}
              onDrag={pos => this.columnDrag(index, pos)}
              onDrop={pos => this.columnDrop(index, pos)}
              style={{width: size}}
              className={`${getClassName('column')} ${c.className || ''}`}>
            <ColumnHeader
                id={c.key}
                label={c.label}
                align={c.align}
                size={size}
                sorted={(c.key === sortColumn)}
                sortDir={(c.key === sortColumn) ? sortDirection : null}
                canSort={sortingAllowed}
                canSize={columnResizingAllowed}
                onSort={(dir) => onSort(c.key, dir)}
                onSize={(size) => onSize(c.key, size)}
                onMove={(from, to) => onMove(from, to)}
            />
          </Draggable>
      )
    })

    if (dragIndex !== null) {
      let dragPos = 0
      if (dragIndex > 0) dragPos = -3
      if (dragIndex === columns.length) dragPos = -6

      const positioner = (
          <div key="_positioner" className={getClassName('positionerContainer')}>
            <div className={getClassName('positioner')} style={{left: dragPos}}/>
          </div>
      )
      content.splice(dragIndex, 0, positioner)
    }

    if (controlColumns) {
      content = [
        ...controlColumns.map((c, index) => {
          return (
              <div key={':sort_' + index} className={getClassName('controlColumn')} style={{width: c.size}}>
                <ColumnHeader
                    label={c.label}
                    align={c.align || "center"}
                    size={c.size}
                    canSort={false}
                    canSize={false}
                />
              </div>
          )
        }),
        ...content,
      ]
    }

    if (actionColumns) {
      content = [
        ...content,
        ...actionColumns.map((c, index) => {
          return (
              <div key={`:action_${index}`} className={getClassName('controlColumn')} style={{width: c.size}}>
                <ColumnHeader
                    label={c.label}
                    align={c.align || "center"}
                    size={c.size}
                    canSort={false}
                    canSize={false}
                />
              </div>
          )
        }),
      ]
    }

    let containerStyle
    const containerClasses = ['container']

    if (!isNil(stickyTop)) {
      containerClasses.push('container-sticky')
      containerStyle = {top: stickyTop}
    }

    return (
        <DragLayer style={containerStyle} className={getClassName(containerClasses)}>
          <div className={getClassName('root')}>
            {content}
          </div>
        </DragLayer>
    )
  }
}

ColumnHeaders.propTypes = {
  columns: propTypes.arrayOf(propTypes.object).isRequired,
  columnSizes: propTypes.object.isRequired,
  sortColumn: propTypes.string,
  sortDirection: propTypes.oneOf(['asc', 'desc']),
  sortingAllowed: propTypes.bool.isRequired,
  columnReorderAllowed: propTypes.bool.isRequired,
  columnResizingAllowed: propTypes.bool.isRequired,
  fullSize: propTypes.bool.isRequired,
  stickyTop: propTypes.number,
  groupOffset: propTypes.number,
  controlColumns: propTypes.arrayOf(propTypes.shape({
    size: propTypes.number.isRequired,
    label: ColumnHeader.propTypes.label,
  })),
  actionColumns: propTypes.arrayOf(propTypes.shape({
    size: propTypes.number.isRequired,
    label: ColumnHeader.propTypes.label,
  })),
  onSize: propTypes.func.isRequired,
  onSort: propTypes.func.isRequired,
  onMove: propTypes.func.isRequired,
  canSelectRows: propTypes.bool,
  onSelectAllRows: propTypes.func,
  onDeSelectAllRows: propTypes.func,
}

ColumnHeaders.defaultProps = {
  groupOffset: 0,
  columnResizingAllowed: true,
}

export default ColumnHeaders
